export default {
  errors: {
    // Permission
    105: "You don't have permission to access this request",

    // license
    106: "Your license has expired",
    107: "Your license is suspended",
    108: "Sorry, your license is not valid",
    // 109: "License Features Not Defined ",
    110: "License is not Genuine. Please renew license or contact admin",
    112: "Sorry, license is not activated",

    // Uploads
    402: "There was a problem in uploading font to the system. Please try again later!",
    403: "There was a problem in uploading font to the system. Please try again later!",
    404: "There was a problem in uploading font to the system. Please try again later!",
    405: "There was a problem in uploading font to the system. Please try again later!",
    406: "Oops! Unable to recognise file type",
    408: undefined,
    409: undefined,
    410: undefined,
    411: undefined,
    412: undefined,
    413: undefined,
    414: "There was a problem in uploading image to the system. Please try again later!",
    415: "There was a problem in uploading font to the system. Please try again later!",
    417: "There was a problem in uploading SVG image to the system. Please try again later",
    418: "Problem in loading font from file. Possible Reasons may be , File is corrupted, PDFBOX doesn't support this File Format. If file is not a ttf file try converting to ttf and then Upload",
    419: "Oops! Cannot upload font from given link",

    // Print Template
    551: 'Template name already exists, try different one!',
    552: undefined,
    553: undefined,
    557: undefined,
    558: undefined,
    559: undefined,
    561: "Oops! Unable to save template. Cannot print some elements in the design.",
    // 562: "Template Already Locked By : "
    563: "You don't have permission to access this template.",
    564: "You don't have permission to access this template.",
    565: 'Only Publisher can modify the Publishing Status.',
    566: "Oops! Cannot delete template added as attachment to email designs",
    574: undefined,
    575: undefined,
    576: "You don't have permission to access this template.",
    577: "You don't have permission to access this template.",
    578: "You don't have permission to access this template.",
    581: undefined,
    582: "You don't have permission to translate this template.",
    583: "You don't have permission to translate this template.",
    584: 'This is read only Template and Cannot be translated',
    // 585: "Storage Service for Processed Pdf should not be Local",

    // Category
    /*************** Error Codes for Category API Starts ************************/
    601: 'Category Name already exists, try different one!',
    602: undefined,
    603: undefined,
    604: undefined,
    605: undefined,
    606: "Category Name can not have more than 45 characters",

    /*************** Error Codes for Folder API Starts ************************/
    701: 'Folder Name already exists, try different one!',
    702: undefined,
    703: undefined,
    704: "Folder doesn't Exists",
    705: "Folder doesn't Exists",
    706: undefined,
    707: undefined,
    708: undefined,
    709: undefined,
    710: undefined,
    711: undefined,
    713: "Folder Name can not have more than 45 characters",

    /*************** Error Codes for Element API Starts ************************/
    751: 'Element Name already exists, try different one!',
    752: "Element Name can not have more than 200 characters",
    753: "Refernced Element is used in below Templates",

    /*************** Error Codes for Team API Starts ************************/
    791: "Nme of the team can not be null and should be Unique",
    792: "Name of the team can not have more than 200 characters",
    793: undefined,
    794: undefined,
    795: "Oops! Cannot delete team already associated with templates / elements / users.",

    /*************** Error Codes for UserManagement API Starts ************************/
    801: "Login Fails. Invalid Credentials",
    802: undefined,
    803: "User with email already exists",
    804: undefined,
    805: undefined,
    806: undefined,
    807: undefined,
    808: undefined,
    809: undefined,
    810: undefined,
    811: undefined,
    812: undefined,
    813: undefined,
    815: undefined,
    816: undefined,
    817: "Sorry, the link has expired",
    818: "Cannot process request.",
    819: "Cannot process request.",
    820: undefined,
    821: "Sorry, Cannot login. Please contact admin.",

    /*************** Error Codes for UserManagement API Starts ************************/
    901: "Unable to reach SMTP server, Please check your credentials.",
    902: "Unable to reach SMTP server, Please check the details.",
    903: "Unable to reach SMTP server",
    904: undefined,
    905: null,
    906: null,
    907: null,
    908: null,
    909: "Variable Name Already Exists",
    910: "Unable to delete variable. Please try again later!",
    912: "Variable Category Name Already Exists",
    913: "Unable to delete Variable Category, Please try again later",
    914: "Template Name Already Exists",
    915: "Invalid Token/Permission",
    916: "Unable to process template",
    917: "Template cannot be processed due to unresolvable variables",
  },
  success: {
    703: 'Template Updated Successfully',
    713: 'Template Updated Successfully',
    728: 'Template submitted for testing',
  },
};
